import * as React from "react";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {
  ArrowDropDown,
  ChevronRight,
  ExpandMore,
  FavoriteBorderOutlined,
  NotificationsOutlined,
} from "@mui/icons-material";
import CustomButton from "./CustomButton";
// import Logo from "/assets/G2i.svg";
import { useNavigate } from "react-router-dom";
import color from "../utils/Colors";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import CustomPopper from "./DropdownPopper";
import { useEffect, useState } from "react";
import { isLoggedIn } from "../../services/axiosClient";
import { categories } from "../utils/Data";
import { getOpenDataFromTable, getProfile } from "../../services/services";
import { useSnackbar } from "../utils/SnackBar";
import { useUser } from "../../services/Context/UserContext";
function Header() {
  const showSnackbar = useSnackbar();
  const [categories, setCategories] = useState<any>([]);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const handleLoginClick = () => {
    navigate("/auth");
  };

  const { setUser, user } = useUser();

  useEffect(() => {
    getProfile()
      .then((result) => {
        if (result?.data?.data) {
          const user = result?.data?.data;
          setUser(user);
        }
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || error?.response?.data?.msg,
        );
      });
  }, []);

  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const handleCategoriesClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCategoriesClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);

  const open1 = Boolean(anchorEl1);

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl1(anchorEl1 ? null : event.currentTarget);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    // Only close the popper if the click is outside the button and popper
    if (anchorEl1 && !(anchorEl1 as any).contains(event.target as Node)) {
      setAnchorEl1(null);
    }
  };
  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: "transparent",
          backgroundImage: "none",
          mt: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // width:'95vw',
          // margin:'auto'
        }}
      >
        <Box sx={{ width: "95vw" }}>
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              // justifyContent: "space-between",
              flexShrink: 0,
              borderRadius: "999px",
              bgcolor:
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.4)"
                  : "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(20px)",
              maxHeight: 40,
              border: "1px solid ",
              borderColor: "divider",
              boxShadow: "0 20px 20px rgba(0, 0, 0, 0.04)",
              p: 5,
              pl: isSmallScreen ? 2 : 5,
              pr: isSmallScreen ? 2 : 5,
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
                gap: { xs: 2, md: 1 },
                justifyContent: "space-between",
                fontSize: "1.8rem",
                fontWeight: "bolder",
                color: "#290854",
                cursor: "pointer",
              }}
            >
              <img
                onClick={() => {
                  navigate("/");
                }}
                src="/assets/G2i.svg"
                alt="Logo"
                width={isSmallScreen ? "80" : "100"}
              />

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {/* <Button
                    aria-controls="categories-menu"
                    aria-haspopup="true"
                    onClick={handleCategoriesClick}
                    sx={{
                      color: color.textColor,
                      mr: { xs: 2, md: 0 },
                      display: { xs: "none", sm: "flex" },
                    }}
                  >
                    Categories <ArrowDropDown />
                  </Button>
              */}
                <Menu
                  id="categories-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCategoriesClose}
                  MenuListProps={{
                    "aria-labelledby": "categories-button",
                  }}
                >
                  {categories.map((category: any) => (
                    <ListItem
                      onClick={handleCategoriesClose}
                      button
                      key={category.id}
                    >
                      <ListItemText primary={category.title} />
                      <ChevronRight />
                    </ListItem>
                  ))}
                </Menu>
                <TextField
                  // variant="outlined"
                  className="input-root2"
                  placeholder="Search..."
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                  sx={{
                    width: { xs: "100%", md: "auto" },
                  }}
                />
              </Box>

              <>
                <Box
                  sx={{
                    display: { xs: "none", md: "flex" },
                    gap: 0.5,
                    alignItems: "center",
                  }}
                >
                  {!isLoggedIn() ? (
                    <CustomButton
                      sx={{
                        bgcolor: "#DBCAE9",
                        color: "black",
                        padding: "10px 25px",
                        borderRadius: "50px",
                        textTransform: "capitalize",
                        mr: 1,
                        fontSize: "1rem",
                        ":hover": {
                          bgcolor: "#DBCAE9",
                        },
                      }}
                      onClick={handleLoginClick}
                    >
                      Log In
                    </CustomButton>
                  ) : (
                    <Box
                      sx={{
                        py: "5px",
                        px: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        cursor: "pointer",
                        // background:'#29085415',
                        mr: -1,
                        mt: -1,
                        mb: -1,
                      }}
                    >
                      <FavoriteBorderOutlined
                        onClick={() => {
                          navigate("/wishlist");
                        }}
                        className="icon"
                      ></FavoriteBorderOutlined>

                      <NotificationsOutlined
                        onClick={() => {
                          navigate("/notification");
                        }}
                        className="icon"
                      ></NotificationsOutlined>

                      <Avatar
                        className="icon"
                        onClick={handleClick}
                        sx={{
                          bgcolor: color.firstColor,
                          fontSize: "14px",
                          width: 24,
                          height: 24,
                          cursor: "pointer",
                        }}
                      >
                        {user?.name[0]}
                      </Avatar>
                      <CustomPopper
                        anchorEl={anchorEl1}
                        open={open1}
                        handleClose={handleClose}
                      />
                    </Box>
                  )}
                </Box>
              </>
            </Box>

            {/* mobile */}

            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                flexDirection: "row",
                // width: "200px",
                alignItems: "center",
                ml: 2,
                justifyContent: "center",
              }}
            >
              {isLoggedIn() ? (
                <>
                  {" "}
                  <Avatar
                    // className="icon"
                    onClick={handleClick}
                    sx={{
                      bgcolor: color.firstColor,
                      fontSize: "14px",
                      width: 24,
                      height: 24,
                      cursor: "pointer",
                    }}
                  >
                    {user?.name[0]}
                  </Avatar>
                  {/* <Button
                    variant="text"
                    aria-label="menu"
                    onClick={toggleDrawer(true)}
                    sx={{
                      minWidth: "30px",
                      ml: 2,
                      color: color.firstColor,
                      p: "4px",
                    }}
                  >
                    <MenuIcon />
                  </Button> */}
                </>
              ) : (
                <CustomButton
                  sx={{
                    bgcolor: "#DBCAE9",
                    color: "black",
                    padding: "10px 25px",
                    borderRadius: "50px",
                    textTransform: "capitalize",
                    mr: 1,
                    fontSize: "1rem",
                    ":hover": {
                      bgcolor: "#DBCAE9",
                    },
                  }}
                  onClick={handleLoginClick}
                >
                  Log In
                </CustomButton>
              )}

              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: "40dvw",
                    p: 2,
                    backgroundColor: "background.paper",
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      mt: 0,
                      p: 2,
                      margin: -2,
                      mb: 1.5,
                      textAlign: "center",
                      background: color.secondColor,
                    }}
                  >
                    <img
                      onClick={() => {
                        navigate("/");
                      }}
                      src="/assets/G2i.svg"
                      alt="Logo"
                      width="60"
                    />
                  </Box>
                  {/* <MenuItem
                    onClick={() => {
                      navigate("/course-info");
                      toggleDrawer(false);
                    }}
                  >
                    Teacher
                  </MenuItem>
                  <MenuItem onClick={toggleDrawer(false)}>Student</MenuItem>
                  <MenuItem onClick={toggleDrawer(false)}>Parents</MenuItem>
                  <MenuItem onClick={toggleDrawer(false)}>Investor</MenuItem> */}

                  {/* <MenuItem>
                    <Accordion
                      style={{
                        borderRadius: "12px",
                        boxShadow: "none",
                        border: "none",
                      }}
                    >
                      <AccordionSummary
                        sx={{ boxShadow: "0", pl: 0, m: 0, mt: -1 }}
                        expandIcon={<ExpandMore />}
                      >
                        Categories
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box display="flex" flexDirection="column">
                          {categories.map((category: any) => (
                            <ListItem
                              onClick={toggleDrawer(false)}
                              button
                              key={category.id}
                            >
                              <ListItemText primary={category.title} />
                              <ChevronRight />
                            </ListItem>
                          ))}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </MenuItem> */}
                  <Divider />
                  {!isLoggedIn ? (
                    <>
                      <MenuItem>
                        <CustomButton>Sign up</CustomButton>
                      </MenuItem>
                      <MenuItem>
                        <CustomButton>Sign in</CustomButton>
                      </MenuItem>
                    </>
                  ) : (
                    <>
                      {" "}
                      <MenuItem>
                        <CustomButton>Sign Out</CustomButton>
                      </MenuItem>
                    </>
                  )}
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
    </div>
  );
}

export default Header;
